module.exports = __webpack_public_path__ + "static/media/sidebar-bgnew.a89cf10b.webp";